var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.71823 11.1831V18H11.3849V11.1831H18V8.51647H11.3849V2H8.71823V8.51647H2V11.1831H8.71823Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }